import { Box } from '@mui/material';
import { useForkRef } from '@mui/material/utils';
import { forwardRef } from 'react';
import { ScrollerProps } from 'react-virtuoso';
import { useStyles } from '../virtualizedTable.styles';
import { useTableScrollerContext } from './useTableScroller';

const SCROLLBAR_HEIGHT = 4;

interface TableScrollerProps extends ScrollerProps {}

const TableScroller = forwardRef<HTMLDivElement, TableScrollerProps>((props, ref) => {
  const { classes } = useStyles();

  const {
    clientWidth,
    scrollWidth,
    handleAddRefToSyncScroll,
    handleAddPrimaryRefToObserve,
    hasHorizontalOverflow,
  } = useTableScrollerContext();

  const scrollerRef = useForkRef(ref, handleAddPrimaryRefToObserve);

  return (
    <Box
      sx={{
        position: 'relative',
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div {...props} className={classes.scroller} ref={scrollerRef} />
      <div
        className={classes.horizontalScrollbar}
        style={{
          position: 'sticky',
          bottom: 0,
          zIndex: 1000,
          width: `${clientWidth}px`,
          overflowX: 'auto',
          height: hasHorizontalOverflow ? SCROLLBAR_HEIGHT : 0,
        }}
        ref={handleAddRefToSyncScroll}
      >
        <div
          style={{
            height: SCROLLBAR_HEIGHT,
            width: `${scrollWidth}px`,
          }}
        />
      </div>
    </Box>
  );
});

export default TableScroller;
